import * as R from 'ramda'
import { t } from 'ttag'

import {
  ACTIONS,
  ROW_ACTIONS,
  HIRE_STATUSES,
  STATUSES_WITH_HIRE,
  getActions,
  getRowActions,
  getFilters,
} from './model'

export const getEnhancedActions = (state, handlers) => {
  const { count, hasMoveCandidatesFeature, isAtsLocked } = state
  const { onDelete, onExport, onMove } = handlers

  return R.map(action => {
    const mapTypeToOnClick = {
      [ACTIONS.MOVE]: onMove,
      [ACTIONS.EXPORT]: onExport,
      [ACTIONS.DELETE]: onDelete,
    }

    const isLocked = R.and(!R.equals(action.type, ACTIONS.EXPORT), isAtsLocked)

    return {
      ...action,
      onClick: mapTypeToOnClick[action.type],
      isDisabled: R.equals(count, 0),
      isLocked: isLocked,
    }
  }, getActions({ count, hasMoveCandidatesFeature }))
}

export const getEnhancedRowActions = (state, handlers) => {
  const { candidate, hasMoveCandidatesFeature, isAtsLocked } = state
  const { onDelete, onEdit, onMove, onHire } = handlers

  return R.map(
    action => {
      const mapTypeToOnClick = {
        [ROW_ACTIONS.EDIT]: () => onEdit({ candidate }),
        [ROW_ACTIONS.MOVE]: () => onMove({ candidate }),
        [ROW_ACTIONS.DELETE]: () => onDelete({ candidate }),
        [ROW_ACTIONS.HIRE]: () => onHire({ candidate }),
      }

      return {
        ...action,
        onClick: mapTypeToOnClick[action.type],
        isLocked: isAtsLocked,
      }
    },
    getRowActions({
      hasMoveCandidatesFeature,
      showHireAction: R.includes(candidate.status, STATUSES_WITH_HIRE),
      isHired: candidate.hire_status === HIRE_STATUSES.HIRED,
    }),
  )
}

export const getTooltipMessage = ({ hasInterview, isInterviewAvailable }) => {
  if (!isInterviewAvailable) {
    return t`To conduct an interview you need to attach an interview template to this job position.`
  }

  if (!hasInterview) {
    return t`To conduct an interview you need to move the candidate back to the interview step.`
  }

  return null
}
